module.exports = __webpack_public_path__ + "img/sq4d_feature_01.80297a53.jpg";